// Texty výběru varianty (`modules/variantPicker.js`).
export default {
  // --- čtení nativního textu Shoptetu ---
  /** „Velikost: M - Skladem >5 ks" (option bez ceny) / „Velikost: 42" (title obrázkové varianty) */
  optionRe: /^([^:]+):\s*(.+?)(?:\s+-\s+(.*))?$/,
  // --- texty ---
  /** výzva po „Do košíku" bez volby; `param` = název parametru Shoptetu („Velikost") */
  choose: (param) => 'Vyberte ' + param.toLowerCase(),
  soldTitle: 'Momentálně nedostupné',
  soldList: (list) => 'Momentálně nedostupné: ' + list,
  lastPieces: (n) => 'Poslední ' + n + ' ks v této velikosti',
  pieces: (n) => n + '\u00A0ks',
};
